import React, { Component, Fragment } from 'react';
import { Formik, Form, Field } from 'formik';
import { Button, Grid, Divider, Message, List, Checkbox } from 'semantic-ui-react'
import DropzoneComponent from 'react-dropzone-component';
import _ from 'underscore';
import { Link } from 'react-router-dom';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';
import '../../../../../node_modules/react-dropzone-component/styles/filepicker.css';
import '../../../../../node_modules/dropzone/dist/min/dropzone.min.css';

import FormsInputsText from '../../inputs/text/forms_inputs_text';
import FormsInputDate from '../../inputs/date';
import FormsInputDropdown from '../../inputs/dropdown';
import FormsInputDropdownSearch from '../../inputs/dropdownsearch';
// import FormsInputsRadioGroup from '../../inputs/radio';
import FormsInputsRadioGroupDynamic from '../../inputs/radiodynamic';
import FormsInputsDropdownAddition from '../../inputs/dropdownaddition';
import FormsInputsTime from '../../inputs/time';

import InpatientClaimValidationSchema from './validation';
import { djsConfig } from '../../../../template/DropZoneTemplate';
import CommonUtility from '../../../../utils/CommonUtility'

const yesNoOptions = [
    { text: 'Yes', value: 'Y' },
    { text: 'No', value: 'N'}
];

// const payableOptions = [
//     { text: 'Employer', value: 'Employer' },
//     { text: 'Employee', value: 'Employee'}
// ];

const paybackOptions = [
    { text: "Employee's Bank Account", value: 'Bank'},
    { text: 'Cheque', value: 'Cheque' },
    { text: "PayNow via NRIC", value: 'PayNow via NRIC'},
    { text: "Reimbursement by Company", value: 'Payroll'},
    { text: "Reimbursement by Insurer", value: 'Insurer'},
];

const paybackOptionBank = [
    { text: "Employee's Bank Account", value: 'Bank'}
];

// const nationalityOptions = [
//     { text: 'American', value: 'American' },
//     { text: 'Australian', value: 'Australian' },
//     { text: 'Burmese', value: 'Burmese' },
//     { text: 'British', value: 'British' },
//     { text: 'Chinese', value: 'Chinese' },
//     { text: 'Filipinos', value: 'Filipinos' },
//     { text: 'Indonesian', value: 'Indonesian' },
//     { text: 'Malaysian', value: 'Malaysian' },
//     { text: 'Singaporean', value: 'Singaporean' },
// ];

var componentConfig = {
    iconFiletypes: ['.jpeg', '.jpg', '.png', '.pdf'],
    showFiletypeIcon: true,
    postUrl: 'no-url'
};
// var djsConfig = {
//     autoProcessQueue: false,
//     addRemoveLinks: true,
// }
// var eventHandlers = { addedfile: (file) => console.log(file) }

const prepareDynamicDropDownSelectionCompany = (list, useValueAsText = false) => {
    const selectedList = list.filter( company => company.memberType.toUpperCase() == "E");

    return _.map(selectedList, (item) => {
        return { text: (useValueAsText === false) ? item.companyName : item.companyId , value: item.companyId };
    })
};

const prepareDynamicDropDownSelectionClaimant = (list, selectedCompany) => {
    const selectedList = list.filter( company => company.companyId === selectedCompany.companyId);
    
    if (selectedList[0]) 
    {
        return selectedList[0].records.map( item => {
            return { text: item.name, value: item.nric }
        })
    } else {
            return []
    }
};

const prepareDynamicDropDownSelectionHospital = (list, useValueAsText = false, useTextAsValue = false) => {
    var sorted = _.sortBy(list, 'n');
    return _.map(sorted, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareDynamicDropDownSelection = (list, useValueAsText = false, useTextAsValue = false) => {
    return _.map(list, (item) => {
        return { text: (useValueAsText === false) ? item.n : item.c , value: (useTextAsValue === false) ? item.c : item.n };
    })
}

const prepareBankOrBranchListOptions = (list) => {
    return _.map(list, (item, index) => {
        return { text: item.n, value: item.c, key: index};
    });
}

const prepareDiagnosisMedicalConditionsOptions = (list) => {
    var _list = _.sortBy(list, 'n')

    return _.map(_list, (item) => {
        return { text: `${item.n} (${item.c})`, value: item.c };
    })
}

const prepareNameOfOperationOptions = (list) => {
    return _.map(list, (item) => {
        return { text: `${item.n} (${item.c})`, value: item.c };
    })
}

const prepareRadioSelection = (list) => {
    return _.map(list, (data) => {
        return { label: data.name, value: data.nric };
    })
};

const SECTION_2_PDF_LINK = 'https://s3.ap-southeast-1.amazonaws.com/mhc.static/Income/Group+Hospital+and+Surgical+Claim_Sep+2022.pdf'

class FormsClaimInpatient extends Component {
    state = {
        files: [],
        error: false,
        errorMessage: null,
        success: false,
        payNowTerm: false  
    }

    componentDidMount(){
        this._reloadPage();
    }

    componentDidUpdate(prevProps){
        const { filteredByCompany } = prevProps
        if(filteredByCompany !== this.props.filteredByCompany){
            this._reloadPage()
        }
    }


    _reloadPage(){
        this.props.getClaimOptionsEclaim(this.props.user.accessToken, this.props.filteredByCompany);
    }
    
    updateFileTest(file, is_invoice_receipt = false) {
        if (is_invoice_receipt) {
            file.upload.is_invoice_receipt = true;
        }

        this.setState({files: [...this.state.files, file]});
    }
    
    removeFile(file) { 
        this.setState({
            files: this.state.files.filter(f => f !== file),
            error:false,
            errorMessage:''});
    }
    renderClaimSubmissionResult() {
        // if (this.state.success === true) {
        //     return (
        //         <Message positive>
        //             <Message.Header>Claims Created Successfully!</Message.Header>
        //             <p>
        //                 <Link to="/app/claimrecords">
        //                     Click here to view the claims now!
        //                 </Link>
        //             </p>
        //         </Message>
        //     );
        // }
        if (this.state.error === true) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the claim</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    checkAttachmentFile() {
        if (this.state.files.find( (file) => file.size >= 5242880)) {
            return (
                <Message negative>
                    <p>
                        { 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.' }
                    </p>
                </Message>
            );
        }
    }

    handleAgreeChange = () => {
        this.setState({ payNowTerm: !this.state.payNowTerm })
    }
    
    render() {
        const { bbl, bl, cl, hl, il, ol, paymentConfig } = this.props.claimOptions;
        const { bankDetail, nric, costCenterName } = this.props.user;


        // app launch config
        const appLaunchConfig = this.props.appLaunchConfig
        const configBenefit = this.props.configBenefit

        let paymentOpions = [];
        const config = configBenefit.featuresConfig;
        const giroOnly = config.giroOnly;
        const cheque = config.chequeOnly;
        const payNow =  config.payNowOnly;
        const payrollOnly =  config.payrollOnly;
        const allowEclaimPaymentByInsurer =  config.allowEclaimPaymentByInsurer;

        //hide Cheque option for following conditions
        if (appLaunchConfig.appLaunchConfig && appLaunchConfig.appLaunchConfig.moh_company_code && (configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.moh_company_code.toLowerCase()
            ||
            configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.smu_company_local_code.toLowerCase()
            ||
            (configBenefit.benefit.companyCode.toLowerCase() === appLaunchConfig.appLaunchConfig.smu_company_international_code.toLowerCase()
              &&
              !appLaunchConfig.appLaunchConfig.smu_program_code.includes(costCenterName.trim().toLowerCase())))
            )
            {
                if (giroOnly) paymentOpions.push(paybackOptions[0])
                if (payNow) paymentOpions.push(paybackOptions[2])
                if (payrollOnly) paymentOpions.push(paybackOptions[3])
                if (allowEclaimPaymentByInsurer) paymentOpions.push(paybackOptions[4])
            }
            else {
                if (giroOnly) paymentOpions.push(paybackOptions[0])
                if (cheque) paymentOpions.push(paybackOptions[1])
                if (payNow) paymentOpions.push(paybackOptions[2])
                if (payrollOnly) paymentOpions.push(paybackOptions[3])
                if (allowEclaimPaymentByInsurer) paymentOpions.push(paybackOptions[4])
            }

        // default payment options
        var _paybackOptions = paymentOpions
        // set default from api if in option
        var isInOption = _paybackOptions.find(item => item.value === paymentConfig.defaults.paymentMethod)
        var _paymentMethod = isInOption ? paymentConfig.defaults.paymentMethod : _paybackOptions[0].value


        return (
            <div>
                {
                    this.state.success
                    &&
                    <Message positive>
                        <p>
                            Claim number { this.props.currentClaimData.transactionNo } registered. Your claim will be processed within 14 working days.
                        </p>
                        <p>
                            Please tap on <span><Link to={`/app/askjoey?type=inpclaim&id=${this.props.currentClaimData.transactionNo}`}>Ask Joey</Link></span> if you have any questions on the claim.
                        </p>
                        <p>
                            <Link to="/app/claimrecords">
                                <Button>
                                    Back to eClaims
                                </Button>
                            </Link>
                        </p>
                    </Message>
                }
                {
                    !this.state.success
                    &&
                    <Formik
                        initialValues={{
                            companyId: this.props.user.companies[0].companyId,
                            claimantId: '',
                            // nationality: 'Singaporean',
                            claimReferenceNo: '',
                            providerName: '',
                            admissionDate: moment(),
                            dischargeDate: moment(),
                            reasonForTreatment: '',
                            nameOfOperation: '',
                            currency: 'SGD',
                            amount: '',
                            accidentRelated: 'N',
                            workRelated: 'N',
                            accidentDate: moment(),
                            accidentTime: moment(),
                            accidentDetails: '',
                            accidentClaimableFromCompany: 'N',
                            claimingFromOtherInsurer: 'N',
                            claimingFromOtherInsurerName: '',
                            // payee: (paymentConfig && paymentConfig.defaults) ? paymentConfig.defaults.payee : 'Employee',

                            // remarks: '', --> replaced with empSubRemarks
                            uploadAttachments: '',
                            symptoms: '',
                            symptomsStartDate: moment(),

                            placeOfAccident: '',
                            empSubRemarks: '',
                            paymentMethod: _paymentMethod,
                            bankName: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.bankName : '',
                            bankNo: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.bankNo : '',
                            branchNo: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.branchNo : '',
                            accountNo: (paymentConfig && paymentConfig.autoFillBankDetails === true) ? bankDetail.accountNo : '',
                            nric: CommonUtility.maskString(nric, {unmaskedPattern:"4"})
                        }}
                        validateOnChange={false}
                        validateOnBlur={false}
                        validationSchema={InpatientClaimValidationSchema}
                        validate={(values) => {
                            // Additional Validation (if any)
                            let error = {};
                            if (this.state.files.length === 0) {
                                error.uploadAttachments = 'No Files Uploaded.';
                            }
                            // if (this.state.files.length > 10) {
                            //     error.uploadAttachments = 'Only a maxmum of 10 files can be uploaded';
                            // }
                            if (this.state.files.find( (file) => file.size >= 5242880 )) {
                                error.maxFileSize = 'The attachment has exceeded the maximum limit of 5MB. Kindly resize and upload the document again.';
                            }
                            if (values.paymentMethod === "PayNow via NRIC" && !this.state.payNowTerm){
                                error.payNowTermUncheck = "Missing information. Please review and check."
                            }
                            return error;
                        }}
                        onSubmit={(values, actions) => {
                            console.log(values, actions);
                            // Additional Validation (if any)
                            // Prepare Data To Submit
                            // 0 - Create a Copy of current "values" object
                            let data = Object.assign({}, values);
                            // 1 - Convert field "admissionDate", "dischargeDate", "symptomsStartDate" to (DD/MM/YYYY) format
                            data.admissionDate = moment(data.admissionDate).format('DD/MM/YYYY');
                            data.dischargeDate = moment(data.dischargeDate).format('DD/MM/YYYY');
                            data.symptomsStartDate = moment(data.symptomsStartDate).format('DD/MM/YYYY');
                            // 2 - Combine and omit fields "accidentDate", "accidentTime" into "accidentDateTime" (DD/MM/YYYY HH:mm)
                            data.accidentDateTime = `${moment(data.accidentDate).format('DD/MM/YYYY')} ${moment(data.accidentTime).format('HH:mm')}`
                            data = _.omit(data, ["accidentDate", "accidentTime"]);
                            // 3 - If accidentRelated = 'N', omit fields "accidentDateTime", "workRelated", "accidentDetails"
                            if (data.accidentRelated === 'N') { data = _.omit(data, ["accidentDateTime", "workRelated", "accidentDetails"]); }
                            // 4 - If claimingFromOtherInsurer = 'N', omit fields "claimingFromOtherInsurerName"
                            if (data.claimingFromOtherInsurer === 'N') { data = _.omit(data, ["claimingFromOtherInsurerName"]); }
                            // 5 - If payee = 'Employer', omit fields "paymentMethod", "bankNo", "branchNo", "accountNo"
                            // if (data.payee === 'Employer') { data = _.omit(data, ["paymentMethod", "bankNo", "branchNo", "accountNo"]); }
                            // 6 - If payee = 'Employee' and paymentMethod = 'Cheque', omit fields "bankNo", "branchNo", "accountNo"
                            if (data.paymentMethod === 'Cheque') { data = _.omit(data, ["bankName", "bankNo", "branchNo", "accountNo"]); }
                            // Submit Data to Action Handler
                            // console.log(data);
                            // this.props.submitInpatientClaim({data, attachments: this.state.files, accessToken: this.props.user.accessToken}, (result, error) => {
                            //     console.log('done');
                            //     if (error) {
                            //         console.log('done-failed');
                            //         actions.setSubmitting(false);
                            //         this.setState({error: true, success: false, errorMessage: error.message});
                            //     }
                            //     if (result) {
                            //         console.log('done-success');
                            //         this.setState({error: false, success: true, errorMessage: null});
                            //     }
                            // });

                            if (this.state.files && this.state.files.length) {
                                data.attachmentDetails = [];
                                
                                data.attachmentDetails = this.state.files.map(e => {
                                    return e.upload.is_invoice_receipt ? 'INV/RCP' : 'DOC'
                                })
                            }

                            this.props.updateCompletedClaimData({
                                data,
                                attachments: this.state.files,
                                accessToken: this.props.user.accessToken
                            });
                        }}
                        render={({
                            values,
                            errors,
                            status,
                            touched,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                        }) => (
                            <Form style={{paddingBottom: 20}}>
                                <Grid container columns={2}>
                                    <Grid.Column width={16}>
                                        <Message warning>
                                            <Message.Header>IMPORTANT</Message.Header>
                                            <p>
                                                Please read these instructions carefully before uploading the documents.
                                            </p>
                                            <List as='ol'>
                                                <List.Item as='li'>
                                                    Please scan, upload original bills and receipts, original bills and receipts must show
                                                    <List.Item as='ol'>
                                                        <List.Item as='li' value='-'>
                                                            claimant’s name;
                                                        </List.Item>
                                                        <List.Item as='li' value='-'>
                                                            date of treatment;
                                                        </List.Item>
                                                        <List.Item as='li' value='-'>
                                                            diagnosis;
                                                        </List.Item>
                                                        <List.Item as='li' value='-'>
                                                            the attending physician’s stamp and signature.
                                                        </List.Item>
                                                        </List.Item>
                                                    </List.Item>
                                                <List.Item as='li'>
                                                    For admission in a Singapore Government/Restructured Hospital, please scan a copy of the Inpatient Discharge Summary/Ambulatory Form/Hospital Pre-Admission Form.
                                                </List.Item>
                                                <List.Item as='li'>
                                                    For admission in a private/overseas hospital, please provide itemised/detailed hospital bill with <a href={SECTION_2_PDF_LINK} target='blank'> Section 2 </a> completed by the attending doctor.
                                                </List.Item>
                                            </List>
                                        </Message>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Hospitalisation Information
                                        </Divider>
                                    </Grid.Column>

                                    {/* <Grid.Column width={16}>
                                        <Field
                                            name="claimantId"
                                            label="Claimant"
                                            component={FormsInputsRadioGroupDynamic}
                                            secondaryLabel=""
                                            choices={prepareRadioSelection(this.props.user.records)}
                                        />
                                    </Grid.Column> */}
                                    {this.props.user.companies.length > 1 &&
                                    <Grid.Column>
                                        <Field
                                            name="companyId"
                                            label="Select Company"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionCompany(this.props.user.companies)}
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>}
                                    <Grid.Column>
                                        <Field
                                            name="claimantId"
                                            label="Select Claimant"
                                            secondaryLabel=""
                                            options={prepareDynamicDropDownSelectionClaimant(this.props.user.companies, _.pick(values,['companyId']))}
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field
                                            name="providerName"
                                            label="Hospital"
                                            options={prepareDynamicDropDownSelectionHospital(hl, false, true)}
                                            component={FormsInputsDropdownAddition}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="admissionDate"
                                            component={FormsInputDate}
                                            label="Admission Date"
                                            secondaryLabel=""
                                            maxDate={moment()}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="dischargeDate"
                                            component={FormsInputDate}
                                            label="Discharge Date"
                                            secondaryLabel=""
                                            minDate={values.admissionDate}
                                            maxDate={moment()}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field
                                            name="reasonForTreatment"
                                            label="Diagnosis / Medical Condition"
                                            options={prepareDiagnosisMedicalConditionsOptions(il)}
                                            component={FormsInputsDropdownAddition}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="symptoms"
                                            label="Description of Symptoms"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="symptomsStartDate"
                                            component={FormsInputDate}
                                            label="Date the Symptoms Started"
                                            secondaryLabel=""
                                            maxDate={values.admissionDate}
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field
                                            name="nameOfOperation"
                                            label="Name of Operation / Surgical Code"
                                            options={prepareNameOfOperationOptions(ol)}
                                            //*component={FormsInputsDropdownAddition}
                                            component={FormsInputDropdownSearch}  //*JW change
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="currency"
                                            options={prepareDynamicDropDownSelection(cl, true)}
                                            label="Currency"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    <Grid.Column>
                                        <Field
                                            name="amount"
                                            label="Amount"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Field
                                            name="empSubRemarks"
                                            label="Remarks (Optional)"
                                            component={FormsInputsText}
                                            secondaryLabel=""
                                        />
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Accident Information
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Field
                                            name="accidentRelated"
                                            options={yesNoOptions}
                                            label="Is this claim for treatment of injury as a result of an accident?"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentDate"
                                                    component={FormsInputDate}
                                                    label="Date of Accident"
                                                    secondaryLabel=""
                                                    maxDate={values.admissionDate}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentTime"
                                                    label="Time of Accident"
                                                    component={FormsInputsTime}
                                                    secondaryLabel=""
                                                    minTime={ moment().startOf('day') }
                                                    maxTime={ moment() }
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="placeOfAccident"
                                                    label="Place of Accident"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column>
                                                <Field
                                                    name="workRelated"
                                                    options={yesNoOptions}
                                                    label="Is it work related?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentDetails"
                                                    label="Give details of how the injury was caused by the accident. (Please enclose a copy of the police report, if any)"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.accidentRelated === "Y")
                                        &&
                                        (values.workRelated === "Y")
                                        &&
                                        (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="accidentClaimableFromCompany"
                                                    options={yesNoOptions}
                                                    label="Are these medical expenses claimable under your company's work injury compensation act policy?"
                                                    secondaryLabel=""
                                                    component={FormsInputDropdown}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    <Grid.Column width={16}>
                                        <Field
                                            name="claimingFromOtherInsurer"
                                            options={yesNoOptions}
                                            label="Have you claimed or do you intend to claim from any insurer, other employer or any other parties for reimbursement of your medical bills? If yes, please state the party that you are claiming from and submit a copy of the settlement letter or payment voucher from the other party."
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                        />
                                    </Grid.Column>
                                    {
                                        (values.claimingFromOtherInsurer === "Y") && (
                                            <Grid.Column width={16}>
                                                <Field
                                                    name="claimingFromOtherInsurerName"
                                                    label="Name of the party that you are claiming from"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                />
                                            </Grid.Column>
                                        )
                                    }

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            Reimbursement Information
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Field
                                            name="paymentMethod"
                                            options={_paybackOptions}
                                            label="Payment to be made by"
                                            secondaryLabel=""
                                            component={FormsInputDropdown}
                                            disabled={!paymentConfig.updateBankInfo}
                                        />
                                    </Grid.Column>

                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column width={16}>
                                                <Message>
                                                    <p>
                                                        The following bank account in your Profile must be your bank account. If you provide us with an inaccurate bank account number, we will not be liable for any losses incurred by you.
                                                    </p>
                                                </Message>
                                            </Grid.Column>
                                        )
                                    }

                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="bankName"
                                                    label="Bank Name"
                                                    secondaryLabel=""
                                                    component={FormsInputsText}
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="branchNo"
                                                    label="Bank Branch"
                                                    secondaryLabel=""
                                                    component={FormsInputsText}
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.paymentMethod === "Bank") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="accountNo"
                                                    label="Bank Account Number"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                    {
                                        (values.paymentMethod === "PayNow via NRIC") &&
                                        (
                                            <Grid.Column>
                                                <Field
                                                    name="nric"
                                                    label="NRIC"
                                                    component={FormsInputsText}
                                                    secondaryLabel=""
                                                    disabled={true}
                                                />
                                            </Grid.Column>
                                        )
                                    }
                                
                                    {
                                    (values.paymentMethod === "PayNow via NRIC") &&
                                        (
                                            <Grid.Column width={16}>
                                                 <Message>
                                                    <p>
                                                    In order for reimbursement transactions to be successful, kindly acknowledge that you have registered for PayNow via NRIC. Otherwise, please select another payment mode to avoid unintended delays in reimbursement.
                                                    </p>
                                                </Message>
                                                <Checkbox
                                                    label='I confirmed that I have registered for PayNow via NRIC.'
                                                    onChange={this.handleAgreeChange}
                                                    checked={this.state.payNowTerm}
                                                />
                                                {
                                                (errors['payNowTermUncheck']) &&
                                                    (
                                                        <Message negative>
                                                            {errors['payNowTermUncheck']}
                                                        </Message>
                                                    )
                                                }
                                        </Grid.Column>
                                        )
                                    }
                                

                                    <Grid.Column width={16}>
                                        <Divider horizontal>
                                            All Required Documents, Documentary Proofs, Medical Reports
                                        </Divider>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        <Message warning>
                                            <p>
                                                Please prepare scanned copy of your supporting documents for upload before proceeding with this new eSubmission.
                                            </p>
                                            <p>
                                                Scan files must meet the following criteria:
                                            </p>
                                            <ul>
                                                <li>
                                                    Acceptable file formats are pdf, jpg, jpeg and png
                                                </li>
                                                <li>
                                                    Maximum allowable size for each attachment is up to 5MB
                                                </li>
                                            </ul>
                                            <p>
                                                Please note that you must keep the original tax invoice(s)/receipt(s) for at least 6 months from claim submission date and must be made readily available upon Insurer's request. Please ensure your email address and handphone number updated in the e-claim portal are correct.
                                            </p>
                                            <p>
                                                When we pay an eligible claim, precedence shall be given in the following order:
                                            </p>
                                            <ul>
                                                <li>
                                                    Employee if they have settled the eligible medical bills by cash
                                                </li>
                                                <li>
                                                    Medisave account as indicated in the tax invoices or bills
                                                </li>
                                                <li>
                                                    Patient's Medisave-Approved Integrated Shield Plan or CPF Medishield Life (if applicable) in accordance with the CPF Act.
                                                </li>
                                            </ul>
                                        </Message>
                                    </Grid.Column>

                                    <Grid.Column width={16}>
                                        {/* TAX INVOICE RECEIPT DOCUMENT */}
                                        <Fragment>
                                            You may upload more than {this.props.configBenefit.featuresConfig.maximumFileUpload} tax invoice/receipt:
                                            
                                            <DropzoneComponent
                                                config={componentConfig}
                                                eventHandlers={
                                                    {
                                                        maxfilesexceeded: (file) => {
                                                            const maxUpload = this.props.configBenefit && this.props.configBenefit.featuresConfig.maximumFileUpload 
                                                            ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                            : 5
                                                            
                                                            alert(`You can only upload up to ${ maxUpload } files!`);
                                                            this.removeFile(file);
                                                            file.previewElement.remove(); // Remove the extra file from the UI
                                                        },
                                                        addedfile: (file) => {
                                                            // console.log(file);
                                                            if(this.state.files.filter(f => f.upload.is_invoice_receipt == true).length >= 5){
                                                                // alert(`You can only upload up to 5 files!`);
                                                                return;
                                                            }
                                                            if (file.type.includes('jpeg')||
                                                                file.type.includes('jpg')||
                                                                file.type.includes('png')||
                                                                file.type.includes('pdf')||
                                                                file.type.includes('heif')||
                                                                file.type.includes('heic')){
                                                                    this.updateFileTest(file, true);
                                                                } else {
                                                                    this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                                }
                                                        },
                                                        removedfile: (file) => {
                                                            this.removeFile(file);
                                                        }
                                                    }
                                                }
                                                djsConfig={{
                                                    ...djsConfig,
                                                    maxFiles: this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    : 5
                                                }}
                                            />
                                            {this.checkAttachmentFile()}
                                            {
                                                (errors['uploadAttachments']) &&
                                                (
                                                    <Message negative>
                                                        {errors['uploadAttachments']}
                                                    </Message>
                                                )
                                            }
                                        </Fragment>

                                        <div style={{ height: 24 }}></div>
                                        
                                        {/* COMMON DOCUMENT */}
                                        <Fragment>
                                            You may upload more than {this.props.configBenefit.featuresConfig.maximumFileUpload} other supporting documents:
                                            <DropzoneComponent
                                                config={componentConfig}
                                                eventHandlers={
                                                    {
                                                        maxfilesexceeded: (file) => {
                                                            const maxUpload = this.props.configBenefit && this.props.configBenefit.featuresConfig.maximumFileUpload 
                                                            ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                            : 5
                                                            
                                                            alert(`You can only upload up to ${ maxUpload } files!`);
                                                            this.removeFile(file);
                                                            file.previewElement.remove(); // Remove the extra file from the UI
                                                        },
                                                        addedfile: (file) => {
                                                            if(this.state.files.filter(f => f.upload.is_invoice_receipt == false).length >= 5){
                                                                // alert(`You can only upload up to 5 files!`);
                                                                return;
                                                            }
                                                            // console.log(file);
                                                            if (file.type.includes('jpeg')||
                                                                file.type.includes('jpg')||
                                                                file.type.includes('png')||
                                                                file.type.includes('pdf')||
                                                                file.type.includes('heif')||
                                                                file.type.includes('heic')){
                                                                    this.updateFileTest(file);
                                                                } else {
                                                                    this.setState({error:true,errorMessage:'Only image file (jpeg, jpg, png) and PDF file are allowed.'})
                                                                }
                                                        },
                                                        removedfile: (file) => {
                                                            this.removeFile(file);
                                                        }
                                                    }
                                                }
                                                djsConfig={{
                                                    ...djsConfig,
                                                    maxFiles: this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    ? this.props.configBenefit.featuresConfig.maximumFileUpload
                                                    : 5
                                                }}
                                            />
                                            {this.checkAttachmentFile()}
                                            {
                                                (errors['uploadAttachments']) &&
                                                (
                                                    <Message negative>
                                                        {errors['uploadAttachments']}
                                                    </Message>
                                                )
                                            }
                                        </Fragment>
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        {this.renderClaimSubmissionResult()}
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        <Button
                                            loading={isSubmitting}
                                            type="submit"
                                            primary
                                            disabled={isSubmitting}
                                            fluid
                                            size="big"
                                        >
                                            Next
                                        </Button>
                                    </Grid.Column>
                                </Grid>
                            </Form>
                        )}
                    />
                }
            </div>
        );
    }
}

export default FormsClaimInpatient;

/*

===> Removal of nationality
<Grid.Column width={16}>
    <Field
        name="claimantId"
        label="Claimant"
        component={FormsInputsRadioGroupDynamic}
        secondaryLabel="Select the individual in correspondence with the claim"
        choices={prepareRadioSelection(this.props.user.records)}
    />
</Grid.Column>
<Grid.Column>
    <Field
        name="nationality"
        label="Nationality Of Claimant"
        options={nationalityOptions}
        component={FormsInputsDropdownAddition}
        secondaryLabel="Input claimant's nationality"
    />
</Grid.Column>
<Grid.Column>
    <Field
        name="claimReferenceNo"
        label="Claim Reference No (If Any)"
        component={FormsInputsText}
        secondaryLabel="Input the unqiue claim reference number if there is one"
    />
</Grid.Column>

===> Removal of payments

<Grid.Column width={16}>
    <Field
        name="claimingFromOtherInsurer"
        options={yesNoOptions}
        label="Intention to Claim From Any Other Parties or Insurer"
        secondaryLabel="Have you claimed or do you intend to claim from any insurer, other employer or any other parties for reimbursement of your medical bills? If yes, please state the part that you are claiming from and submit a copy of the settlement letter of payment voucher from the other party."
        component={FormsInputDropdown}
    />
</Grid.Column>
{
    (values.claimingFromOtherInsurer === "Y") && (
        <Grid.Column width={16}>
            <Field
                name="claimingFromOtherInsurerName"
                label="Name of the party that you are claiming from"
                component={FormsInputsText}
                secondaryLabel="Input names of the parties (if any) that you are claiming from"
            />
        </Grid.Column>
    )
}
<Grid.Column width={16}>
    <Divider horizontal>
        Reimbursement Information
    </Divider>
</Grid.Column>

<Grid.Column>
    <Field
        name="payee"
        options={payableOptions}
        label="Benefits Should Be Payable To"
        secondaryLabel="Select who is to be paid for this claim"
        component={FormsInputDropdown}
        disabled={!paymentConfig.updateBankInfo}
    />
</Grid.Column>
{
    (values.payee === "Employee") && (
        <Grid.Column>
            <Field
                name="paymentMethod"
                options={paybackOptions}
                label="Payment to be made by"
                secondaryLabel="Select desired reimbursement method"
                component={FormsInputDropdown}
                disabled={!paymentConfig.updateBankInfo}
            />
        </Grid.Column>
    )
}
{
    (values.payee === "Employee") &&
    (values.paymentMethod === "Bank") &&
    (
        <Grid.Column>
            <Field
                name="bankNo"
                options={prepareDynamicDropDownSelection(bl)}
                label="Bank Name"
                secondaryLabel="Select your bank to be reimbursed"
                component={FormsInputDropdown}
                disabled={!paymentConfig.updateBankInfo}
            />
        </Grid.Column>
    )
}
{
    (values.payee === "Employee") &&
    (values.paymentMethod === "Bank") &&
    (
        <Grid.Column>
            <Field
                name="branchNo"
                options={(values.bankNo) ? prepareDynamicDropDownSelection(bbl[values.bankNo]) : []}
                label="Bank Branch"
                secondaryLabel="Select your bank branch"
                component={FormsInputDropdown}
                disabled={!paymentConfig.updateBankInfo}
            />
        </Grid.Column>
    )
}
{
    (values.payee === "Employee") &&
    (values.paymentMethod === "Bank") &&
    (
        <Grid.Column>
            <Field
                name="accountNo"
                label="Bank Account Number"
                component={FormsInputsText}
                secondaryLabel="Input your bank account number"
                disabled={!paymentConfig.updateBankInfo}
            />
        </Grid.Column>
    )
}
<Grid.Column width={16}>
    <Field
        name="remarks"
        label="Remarks (Optional)"
        component={FormsInputsText}
        secondaryLabel="Input additional comments or remarks if required"
    />
</Grid.Column>
*/

/*

<Grid.Column width={8}>
    <Field
        name="claimReferenceNo"
        label="Claim Reference No (If Any)"
        component={FormsInputsText}
        secondaryLabel="Input the unqiue claim reference number if there is one"
    />
</Grid.Column>
*/
/*
<Grid.Column width={16}>
    <Field
        name="accidentClaimableFromCompany"
        options={yesNoOptions}
        label="Claimable Under Work Injury Compensation Act"
        secondaryLabel="Are these medical expenses claimable under your company's work injury compensation act policy?"
        component={FormsInputDropdown}
    />
</Grid.Column>
*/
